import { type TTailwindString, tw } from "classnames";

export interface FocusUtilityClasses {
  ring: TTailwindString;
  ringInset: TTailwindString;
  ringProductCard: TTailwindString;
}

/**
 * Standard focus ring utility for consistent keyboard navigation styling.
 * Provides a visible outline for focusable elements when navigated via keyboard.
 *
 * @example
 * ```tsx
 * <button className={tw("px-4 py-2", focusRing)}>
 *   Click me
 * </button>
 * ```
 */
export const focusUtilities: FocusUtilityClasses = {
  ring: tw("tbsp-focus-ring" as TTailwindString),
  ringInset: tw("tbsp-focus-ring-inset" as TTailwindString),
  ringProductCard: tw("tbsp-focus-ring-product-card" as TTailwindString),
};

/**
 * Inset focus ring utility for elements that need internal focus styling.
 * Useful for components where the standard outline would be clipped or interfere with layout.
 *
 * @example
 * ```tsx
 * <div className={tw("relative", focusRingInset)}>
 *   <input className="w-full" />
 * </div>
 * ```
 */
export const focusRing = focusUtilities.ring;

export const focusRingInset = focusUtilities.ringInset;

/** Focus ring that only shows on :focus-visible (e.g. Tab), not on click. Use for product card links. */
export const focusRingProductCard = focusUtilities.ringProductCard;
